import { gql, useMutation } from '@apollo/client';
import {
    DSP_FINANCE_INFO_FIELDS,
    DspFinanceInfoInput,
    DspFinanceInfoType
} from '../types/DspFinanceInfoType';

/** 总部：保存 DSP 财务档案；账期属 DSP 基础信息，随 saveDspWithWarehouses 保存 */
export const SAVE_DSP_FINANCE_INFO = gql`
    mutation SaveDspFinanceInfo($dspId: String!, $input: DspFinanceInfoInput!) {
        saveDspFinanceInfo(dspId: $dspId, input: $input) {
            ...DspFinanceInfoFields
        }
    }
    ${DSP_FINANCE_INFO_FIELDS}
`;

/** DSP Owner：自助维护财务档案 */
export const SAVE_MY_DSP_FINANCE_INFO = gql`
    mutation SaveMyDspFinanceInfo($input: DspFinanceInfoInput!) {
        saveMyDspFinanceInfo(input: $input) {
            ...DspFinanceInfoFields
        }
    }
    ${DSP_FINANCE_INFO_FIELDS}
`;

export const useSaveDspFinanceInfo = () =>
    useMutation<
        { saveDspFinanceInfo: DspFinanceInfoType },
        { dspId: string; input: DspFinanceInfoInput }
    >(SAVE_DSP_FINANCE_INFO);

export const useSaveMyDspFinanceInfo = () =>
    useMutation<{ saveMyDspFinanceInfo: DspFinanceInfoType }, { input: DspFinanceInfoInput }>(
        SAVE_MY_DSP_FINANCE_INFO
    );
